import styled from 'styled-components';

export const SectionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-top: 2.75rem;
  padding-bottom: 1.5rem;
`;

export const SectionBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
